// extracted by mini-css-extract-plugin
export default {"table_row":"TableHeader_table_row__xVdhE","header":"TableHeader_header__hadQY","table_cell":"TableHeader_table_cell__+mUbp"};